import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import CheckboxContainer from '../../CheckboxContainer/CheckboxContainer';
import Card from '../../Fuse/Card';
import RedirectRulesOptionsStore from '../../../stores/Policy/RedirectRules/RedirectRulesOptionsStore';
import FuseReadOnlyCheckbox from '../../FuseControls/FuseReadOnlyCheckbox';
import FuseInfoTooltip from '../../FuseControls/FuseTooltip/FuseInfoTooltip';
import PolicyStore from '../../../stores/Policy/PolicyStore';
import './RedirectRulesOptions.css';

const block = b.lock('RedirectRulesOptions');

class RedirectRulesOptions extends Component {
    static propTypes = {
        store: RedirectRulesOptionsStore.PropType.isRequired,
        policy: PolicyStore.PropType.isRequired,
        readOnly: PropTypes.bool,
    };

    render() {
        const { store, readOnly, policy } = this.props;
        const { includeRecentlyScanned } = store;
        const disable = policy.redirectRules.showNoBrowsingRoleEnabledAlert.getValue();

        return <Card title="Options" className={block()} >
            <CheckboxContainer className={block('RowContainer')} >
                <FuseReadOnlyCheckbox
                    readOnly={readOnly}
                    disabled={disable}
                    className={block('Checkbox')}
                    store={includeRecentlyScanned}
                    label={'Redirect all matching URLs with a recent scan status of “No Threat Detected.”'}
                    readOnlyValue={includeRecentlyScanned.isTrue ?
                        'Redirect all matching URLs with a recent scan status of “No Threat Detected.”' :
                        'Do not redirect all matching URLs with a recent scan status of “No Threat Detected.”'}
                />
                <FuseInfoTooltip
                    className={block('Info', { readOnly })}
                >
                    Recently scanned means that in the past 30 minutes, a full sandbox threat scan was
                    performed.<br/><br/>When enabled, matching URLs with a recent scan status of “No Threat Detected
                    will still redirect to Isolation.<br/><br/>When disabled, matching URLs with a recent
                    scan status of “No Threat Detected” will not redirect.
                </FuseInfoTooltip>
            </CheckboxContainer>
        </Card>;
    }
}

export default inject('policy')(observer(RedirectRulesOptions));
